// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-5cfbeb80] {\r\n  background: var(--principal-azul);\r\n  width: 27px;\r\n  height: 27px;\r\n  overflow: hidden;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\n}\n.btn img[data-v-5cfbeb80]{\r\n  filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(124deg) brightness(106%) contrast(101%);\n}\r\n", ""]);
// Exports
module.exports = exports;
